import { BrowserRouter, Route, Routes } from "react-router-dom";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import HomePageOne from "./pages/HomePageOne";
import HomePageTwo from "./pages/HomePageTwo";
import HomePageThree from "./pages/HomePageThree";
import ProductDetailsPageOne from "./pages/ProductDetailsPageOne";
import ProductDetailsPageTwo from "./pages/ProductDetailsPageTwo";
import CartPage from "./pages/CartPage";

import AccountPage from "./pages/AccountPage";
import BlogPage from "./pages/BlogPage";
import BlogDetailsPage from "./pages/BlogDetailsPage";
import ContactPage from "./pages/ContactPage";
import PhosphorIconInit from "./helper/PhosphorIconInit";
import VendorPage from "./pages/VendorPage";
import VendorDetailsPage from "./pages/VendorDetailsPage";
import VendorTwoPage from "./pages/VendorTwoPage";
import VendorTwoDetailsPage from "./pages/VendorTwoDetailsPage";
import WishListOne from "./pages/WishListOne/WishListOne.jsx"

// my import new 
import AllCategoriesOne from './pages/ViewAllCategories/AllCategoriesOne'
import ProductListOne from "./pages/ProductListOne/ProductListOne";
import CartPageOne from "./pages/CartPageOne";
import BusinessDashboard from "./components/dashboard/business/BusinessDashboard";
import UserDashboard from "./components/dashboard/user/UserDashboard";
import CheckOutOne from "./pages/CheckOutPageOne/CheckOutOne.jsx";
import BecomeSellerOne from './pages/BecomeSeller/BecomeSellerOne.jsx'
import SellerForm from "./pages/BecomeSeller/SellerForm.jsx";

//For business 
import Profile from "./components/dashboard/business/Profile/Profile.jsx";
import Orders from "./components/dashboard/business/Orders/Orders.jsx";
import Wallet from "./components/dashboard/business/Wallet/Wallet.jsx"
import ClaimVoucher from "./components/dashboard/business/Wallet/ClaimVoucher.jsx"
import CreateVoucher from "./components/dashboard/business/Wallet/CreateVoucher.jsx";
import History from "./components/dashboard/business/Wallet/History.jsx";

// For User
import Profile1 from "./components/dashboard/user/Profile/Profile.jsx";
import Orders1 from "./components/dashboard/user/Orders/Orders.jsx";
import Wallet1 from "./components/dashboard/user/Wallet/Wallet.jsx"
import ClaimVoucher1 from "./components/dashboard/user/Wallet/ClaimVoucher.jsx";
import CreateVoucher1 from "./components/dashboard/user/Wallet/CreateVoucher.jsx";
import History1 from "./components/dashboard/user/Wallet/History.jsx";
import Payments from "./components/dashboard/user/Payments.jsx";

//Forgot Password
import ForgotPassword from "./pages/ForgotPassword/ForgotPasswordPage.jsx";
import ResetPassword from "./pages/ResetPassword/ResetPasswordPage.jsx";
import ViewOrder from "./components/dashboard/user/Orders/ViewOrder.jsx";
import TrackOrder from "./components/dashboard/user/Orders/TrackOrder.jsx";
import CancelOrder from "./components/dashboard/user/Orders/CancelOrder.jsx";
import ReturnReplace from "./components/dashboard/user/Orders/ReturnReplace.jsx";
import Invoice from "./components/dashboard/user/Orders/Invoice.jsx";
import AboutUs from "./components/AboutUs.jsx";
import PrivacyPolicy from "./components/PrivacyPolicy.jsx";
import ShippingPolicy from "./components/ShippingPolicy.jsx";
import OrderPolicy from "./components/OrderPolicy.jsx";
import TermOfUse from "./components/TermOfUse.jsx";
import RefundPolicy from "./components/RefundPolicy.jsx";
import PaymentPolicy from "./components/PaymentPolicy.jsx";
import VendorPolicy from "./components/VendorPolicy.jsx";
import MarketPlace from "./components/MarketPlace.jsx";
import PaymentSuccess from "./components/PaymentSuccess.jsx";
import VendorProducts from "./pages/VendorProducts.jsx";


function App() {
  
  return (
    <BrowserRouter>
      <RouteScrollToTop />
      <PhosphorIconInit />

      <Routes>
        <Route exact path='/' element={<HomePageOne />} />
        <Route exact path='/index-two' element={<HomePageTwo />} />
        <Route exact path='/index-three' element={<HomePageThree />} />
        <Route exact path='/all-categories-one' element={<AllCategoriesOne />} />
        <Route exact path='/product-list-one' element={<ProductListOne />} />
        <Route exact path='/shop' element={<ProductListOne />} />



        {/* User Dashboard Routes */}
        <Route path="/user/*" element={<UserDashboard />} />
        <Route path="/user/profile" element={<Profile1 />} />
        <Route path="/user/orders" element={<Orders1 />} />
        <Route path="/user/orders/:orderId" element={<ViewOrder />} />
        <Route path="/user/orders/:orderId/track" element={<TrackOrder />} />
        <Route path="/user/orders/:orderId/cancel" element={<CancelOrder />} />
        <Route path="/user/orders/:orderId/return" element={<ReturnReplace />} />
        <Route path="/user/orders/:orderId/invoice" element={<Invoice />} />
        <Route path="/user/payment" element={<Payments />} />
        <Route path="/user/wallet*" element={<Wallet1 />} />
        <Route path="/user/wallet/claim" element={<ClaimVoucher1 />} />
        <Route path="/user/wallet/create" element={<CreateVoucher1 />} />
        <Route path="/user/wallet/history" element={<History1 />} />     
         
        
        {/* Business Dashboard Routes */}
        <Route path="/business/*" element={<BusinessDashboard />} />
        <Route path="/business/profile" element={<Profile />} />
        <Route path="/business/orders*" element={<Orders />} />
        <Route path="/business/wallet" element={<Wallet />} />
        <Route path="/business/wallet/claim" element={<ClaimVoucher />} />
        <Route path="/business/wallet/create" element={<CreateVoucher />} />
        <Route path="/business/wallet/history" element={<History />} />

      
        <Route exact path='/product-details/:id' element={<ProductDetailsPageOne />} />
        <Route exact path='/product-details-two' element={<ProductDetailsPageTwo />} />
        <Route exact path='/vendor/:id' element={<VendorProducts />} />
       

        {/* <Route exact path='/cart' element={<CartPage />} /> */}
        <Route exact path='/cart-one' element={<CartPageOne />} />
        <Route exact path='/checkout' element={<CheckOutOne />} />
        <Route exact path='/become-seller' element={<BecomeSellerOne />} />
        <Route exact path='/seller-form' element={<SellerForm />} />
        <Route exact path='/wishlist' element={<WishListOne />} />
        <Route exact path='/account' element={<AccountPage />} />
        <Route exact path='/blog' element={<BlogPage />} />
        <Route exact path='/blog-details' element={<BlogDetailsPage />} />
        <Route exact path='/contact' element={<ContactPage />} />
        <Route exact path='/vendor' element={<VendorPage />} />
        <Route exact path='/vendor-details' element={<VendorDetailsPage />} />
        <Route exact path='/vendor-two' element={<VendorTwoPage />} />
        <Route exact path='/vendor-two-details' element={<VendorTwoDetailsPage />}/>

        <Route path="/payment-success" element={<PaymentSuccess />} />

        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />

        <Route path="/about-us" element={<AboutUs />} />  
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />  
        <Route path="/shipping-policy" element={<ShippingPolicy />} />  
        <Route path="/order-policy" element={<OrderPolicy />} />  
        <Route path="/terms-of-use" element={<TermOfUse />} />  
        <Route path="/payment-policy" element={<PaymentPolicy />} />  
        <Route path="/refund-policy" element={<RefundPolicy />} />  
        <Route path="/vendor-policy" element={<VendorPolicy />} />  
        <Route path="/marketplace-declaration" element={<MarketPlace />} />  
      </Routes>
    </BrowserRouter>
  );
}

export default App;
